module.exports = __webpack_public_path__ + "img/set-up-icon.146feb8a.svg";